module.exports = __webpack_public_path__ + "static/media/amphi.43ec38b6.svg";